import { isCapabilityEnabled } from 'owa-capabilities';
import { myDayPerWorkloadPersistenceCapability } from 'owa-capabilities-definitions/lib/myDayPerWorkloadPersistenceCapability';

/**
 * The gate for My Day per-workload persistence: the flight must be on AND the current host must
 * be one the feature is meant for. Every entry point calls this instead of reading the flight
 * directly, so no path can reach the feature with only half the condition checked.
 *
 * The host and flight conditions live in myDayPerWorkloadPersistenceCapability as `isSupported`
 * and `isEnabled`; isCapabilityEnabled requires both.
 */
export function isPerWorkloadPersistenceEnabled(): boolean {
    return isCapabilityEnabled(myDayPerWorkloadPersistenceCapability);
}
